import { ItemData } from 'core/models/Template'

export const CLASSROOMS_CATALOG_TYPE = 'classrooms' as const

export const CLASSROOMS_CATALOG_CONFIG = {
    type: CLASSROOMS_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type ClassroomsSelectedItems = ItemData[]
